import { useMutation as e, useQueryClient as t } from "@maat/store-hooks";
import { propertyAmenitiesApi as n } from "@maat/api-main";
//#region src/propertyAmenities/useSetPropertyAmenityPopularMutation.ts
var r = () => {
	let r = t();
	return e({
		mutationFn: ({ id: e, isPopular: t }) => n.setPopular(e, t),
		onSuccess: () => {
			r.invalidateQueries({ queryKey: ["propertyAmenities"] });
		}
	});
};
//#endregion
export { r as useSetPropertyAmenityPopularMutation };
